import {ModalController, AlertController, ViewController, NavController, NavParams, Keyboard} from 'ionic-angular';
import {Component} from '@angular/core';
import {AppDialog} from "../../component/appDialog";
import { UserService } from "../../services/user.services";
import { TabsPage } from "../tabs/tabs";
import { AppConfig } from "../../util/appConfig";
import {UserEditPage} from "../userEdit/userEdit";

//和下级投注样式差不多历史一样
@Component({
  templateUrl: 'improveUser.html',
  selector: 'improve-user-page',
})
export class ImproveUserPage{
  nickName: string;
  email: string;
  newPwd: string;
  fundPwd: string;
  paramUser: any;
  loginName: string;
  appName: string;
  acceptPolicy: boolean;
  phone:string;

  constructor(private modalCtrl: ModalController, private viewCtrl: ViewController, private keyboard: Keyboard,private navParams: NavParams, private nav: NavController, private alertCtrl: AlertController, private userService: UserService) {
    this.paramUser = navParams.get('paramUser');
    this.loginName = this.paramUser['loginname'];
    this.appName = AppConfig.appName;
    this.acceptPolicy = false;
  }

  updateFn() {
    let updateData: any = {
      uNickname: this.nickName,
      uEmail: this.email,
      uPwd: this.newPwd,
      uCheckpwd: this.fundPwd, 
      uPhone: this.phone
    };
    if (!this.acceptPolicy){
      AppDialog.alert({
        alertCtrl: this.alertCtrl,
        message: "Xin hãy đọc và chấp thuật điều khoản"
      });
    } else {
      this.userService.updateUserInfo(updateData, this.alertCtrl).then(data=> {
        if(!data["msg"]) {
            if(!data["user"]["verifiedphone"]) {
                this.nav.push(TabsPage, {
                    paramUser: data["user"]
                }).then(() => {
                    this.nav.push(UserEditPage, {userData: data["user"], selectAction: true});
                });
            } else {
                this.nav.push(TabsPage, {
                    paramUser: data["user"]
                }).then(() => {
                    let index = this.viewCtrl.index;
                    this.nav.remove(index);
                });
            }
        } else {
          AppDialog.alert({
            alertCtrl: this.alertCtrl,
            message: data["msg"]
          });
        }
      });
    }
  }
  policy() {
    let modal = this.modalCtrl.create(ModalContentPolicyPage);
    modal.present();
  }

  ionViewWillLeave(){
    this.keyboard.close();
  }
}

@Component({
  template: `
  <ion-header align-title="center">
    <ion-navbar align-title="center">
      <ion-title>
        Điều khoản
      </ion-title>
    </ion-navbar>
  </ion-header>
  <ion-content>
    <ion-card-content text-wrap>
        <p>
            LODEVN99 là trang trò chơi trực tuyến được cấp giấy phép kinh doanh hợp pháp bởi nước Cộng Hòa Philippines, được giới hạn và bảo vệ bởi pháp luật nước sở tại. Trước khi người chơi đăng nhập vào trang web, cần đọc kĩ những nội dung sau, và xác nhận trang web phù hợp với luật pháp quy định tại quốc gia và nơi cư trú của người chơi. Chúng tôi không chịu trách nhiệm với bất cứ hành vi vi phạm quy định của quốc gia sở tại của người chơi. Người chơi sau khi đăng nhập vào trang web đồng nghĩa với việc hoàn toàn chấp nhận tất cả các quy định của trang web. 
        </p>
        <p>
            <b>1.Thỏa thuận giao dịch</b>
        </p>
        <p>
            <b>1.1</b> Tất cả kết quả mở thưởng của công ty chúng tôi đều sử dụng kết quả mở thưởng của bên thứ ba tin cậy, dựa vào số liệu chính thức của trang cá cược làm chuẩn.
        </p>
        <p>
            <b>1.2</b> Sau khi khách hàng đặt cược tại trang web của chúng tôi, cần kiểm tra lại lịch sử cược, để chắc chắn đặt cược thành công và tránh các tranh luận có thể xảy ra; trong quá trình đặt cược, nếu có vấn đề về đường truyền mạng dẫn đến không thể kết nối với máy chủ của chúng tôi, tất cả đơn đặt cược đã xác nhận vẫn có hiệu lực, sau khi khách hàng đăng nhập lại, có thể kiểm tra lại và xác nhận lịch sử đặt cược.
        </p>
        <p>
            <b>1.3</b> Khách hàng chuyển khoản trên trang web của chúng tôi, cần phải tuân theo đúng quy trình quy định, xác nhận thông tin tài khoản đích là tài khoản được chúng tôi cung cấp có hiệu lực tại thời điểm giao dịch, nếu do điền thông tin sai (số tài khoản và số giao dịch) dẫn đến tài khoản đích không nhận được hoặc không đúng thời hạn, chúng tôi sẽ không chịu bất cứ trách nhiệm nào, ngoài ra chúng tôi có quyền xét phạt tài khoản điền số giao dịch sai phạm.
        </p>
        <p>
            <b>1.4</b> Trước khi người chơi rút tiền từ trang web của chúng tôi, cần xác nhận tài khoản ngân hàng sử dụng là chính chủ. Nếu do tài khoản ngân hàng cá nhân thay đổi mà không kịp thời báo với trang web dẫn đến tổn thất, chúng tôi không chịu bất cứ trách nhiệm gì.
        </p>
        <p>
           <b>1.5</b> Tài khoản có lịch sử số giao dịch và số dư ≤ 1k , 30 ngày liên tục không có thay đổi về số dư (không nạp tiền, không rút tiền, không đặt cược, không hoàn tiền), sẽ bị khóa, sau khi khóa 15 ngày và không có cấp dưới, sẽ bị hệ thống xóa; tài khoản mới tạo quá 7 ngày liên tục không có thay đổi về số dư sẽ bị khóa, khóa sau 7 ngày liên tục và không có cấp dưới, sẽ bị hệ thống xóa. 
        </p>
        <p>
            <b>1.6</b> Người chơi tại trang của chúng tôi, nếu có hành vi gian lận, công kích, phá hoại sự vận hành của trang web, hoặc lợi dụng lỗ hổng của hệ thống xâm hại trang web và quyền lợi của các khách hàng khác, sau khi xác thực, chúng tôi có quyền khóa tài khoản, đóng băng và xóa tài khoản người chơi, ngăn chặn người chơi tiếp tục sử dụng trang web, và có quyền thu lại toàn bộ tài sản đạt được từ các hành vi trên.
        </p>
        <p>
            <b>1.7</b> Khách hàng chơi trên trang của chúng tôi có thể kiểm tra lịch sử giao dịch, lịch sử này sẽ được xóa trong một thời gian bất định, trước khi xóa người chơi có thể kiểm tra, nếu có tranh luận, sẽ xử lý dựa vào dữ liệu cuối cùng được lưu lại của trang web chúng tôi.
        </p>
        <p>
            <b>2. Tuyên bố trách nhiệm </b>
        </p>
        <p>
            <b>2.1</b> Người chơi bắt buộc từ 18 tuổi trở lên mới có thể chơi tại trang web của chúng tôi, không nên quá ham mê vào trò chơi.
        </p>
        <p>
            <b>2.2</b> Tất cả bất cứ hoạt động và thao tác đăng nhập bằng tài khoản và mật khẩu tại trang web, sẽ được coi là thao tác hữu hiệu. Người chơi có trách nhiệm bảo quản tài khoản, mật khẩu và các thông tin cá nhân khác của mình. Nếu thông tin cá nhân của người chơi không thích đáng dẫn đến bị dùng trộm (ví dụ bị nhiễm virut v.v), sau khi người chơi phát hiện, cần lập tức thông báo cho đại lý cấp trên hoặc chúng tôi để đóng băng tài khoản, thay đổi thông tin, để tránh các tổn thất; trong trường hợp đã bị tổn thất về tài sản hoặc tiền bạc, chúng tôi sẽ không chịu bất cứ trách nhiệm nào.
        </p>
        <p>
            <b>2.3</b> Trang web của chúng tôi sử dụng phần mềm “chat trực tuyến” và là cách duy nhất cung cấp dịch vụ tư vấn ngay lập tức cho người chơi. Nếu người chơi được tư vấn bằng cách khác, công ty chúng tôi không đảm bảo tính xác thực, và không chịu bất cứ trách nhiệm nào.
        </p>
        <p>
            <b>2.4</b> Chúng tôi khuyên người chơi nên thay đổi mật khẩu, cược, nạp tiền, rút tiền và các thao tác khác tại trang web của chúng tôi, chúng tôi không ủy quyền cho người khác (bất cứ cá nhân hoặc đoàn thể nào) giúp người chơi tiến hành các thao tác trên, người chơi thông qua người khác thao tác dẫn đến tổn thất, chúng tôi sẽ không chịu bất cứ trách nhiệm nào.
        </p>
        <p>
            <b>2.5</b> Email người chơi ràng buộc trên trang web của chúng tôi cần phải là email thật và có hiệu lực; sau khi ràng buộc email, không được thay đổi, nếu do người chơi ràng buộc sai dẫn đến tổn thất, chúng tôi sẽ không chịu bất cứ trách nhiệm nào.
        </p>
        <p>
            <b>2.6</b> Trong trường hợp do thiên tai tự nhiên hoặc do nhân tố bên thứ ba không thể kháng cự, ví dụ sự cố ISP (nhà cung cấp dịch vụ Internet), người chơi bị hạn chế tại quốc gia sở tại, dẫn đến thông tin trang web bị tổn hại, bị mất thông tin, đăng nhập dị thường, v.v, trang của chúng tôi không chịu bất cứ trách nhiệm nào, nhưng chúng tôi sẽ cố gắng hết sức để giảm thiểu tổn thất cho người chơi, và người chơi có nghĩa vụ phối hợp để giảm bị ảnh hưởng.
        </p>
        <p>
            <b>2.7</b> Trang web của chúng tôi có quyền thay đổi trong thời gian bất định, sau khi cập nhật các điều khoản và thông báo, khi người chơi tiếp tục sử dụng trang web, sẽ đồng nghĩa với việc người chơi đồng ý và chấp nhận tất cả các thay đổi về điều khoản trang và luật chơi của trang web.
        </p>
        <p>
            <b>2.8</b> Công ty chúng tôi có quyền giải thích và sửa đổi đối với những điều khoản chưa liệt kê tại đây.
        </p>
    </ion-card-content>
    <div class="button-container">
      <button ion-button (click)="dismiss()" block  default>
        Thoát
      </button>
    </div>
  </ion-content>
  `,
  selector: 'improve-user-page'
})
export class ModalContentPolicyPage {

  constructor(private params: NavParams, private viewCtrl: ViewController){} 
  dismiss() {
        this.viewCtrl.dismiss();
  }

}




// WEBPACK FOOTER //
// ./src/pages/improveUser/improveUser.ts